import axios from "axios";
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
import { common } from "../../utils";
import { API_URL } from "./../../utils/api-utils";
//Material
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import { BoxTemplate1 } from "../../stories/Box";
import './styles.css';
//Component
import { BaseContainer } from "../../stories/base-container";
import { ReactTable } from "../../stories/react-table";
//Function
import { titleCase } from "../../utils/common-function";
import { ToDateText, ToDateTimeText } from "../../utils/date";
import * as alertDialog from "../../utils/alert";
// Context
import {
  LoadingContext,
  withLoadingContext,
} from "../../context/loading-context";

function OutboundInventory() {
  //Context
  const Loading_context = useContext(LoadingContext);
  const { actions: load_actions } = Loading_context;
  //State
  const [DataList, setDataList] = useState([]);

  //---------------------------
  const fetch = useCallback(async () => {
    let res = await load_actions.withLoading(() => GetOutboundInventory());
    if (!res) return;
    if(res.Status === "Error")
    {
      alertDialog.Inform(res.Message);
    }
    else{
      setDataList(res.ListOutboundInventory);
    }
  }, [load_actions]);
  useEffect(() => {
    fetch();
  }, [fetch]);

  //Function

  return (
    <>
      <BaseContainer>
      {Loading_context.state?.isLoading ? (
          <div className="lineLoading">
            <LinearProgress />
          </div>
        ) : null}
        {/* <Typography style={{ marginLeft: "5px" }}>
          Outbound Inventory
        </Typography> */}
        <BoxTemplate1 height="80vh"  title="Outbound Inventory">
        <ReactTable
        tdStyle={{ whiteSpace: 'normal', wordWrap: 'break-word' }} 
        //tdStyle={}
          keyField="ROW_NUMBER"
          data={DataList}
          columns={getOutboundInventoryColumns()}
          exportCsv
          hover
        />
        </BoxTemplate1>
      </BaseContainer>
    </>
  );
}

// Column
const getOutboundInventoryColumns = () => {
  const columns = [
    {
      dataField: "PROCESS_NAME",
      text: titleCase("PROCESS_NAME"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "DATA_FILENAME",
      text: titleCase("DATA_FILENAME"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "QUEUENAME",
      text: titleCase("QUEUENAME"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "DESCRIPTION",
      text: titleCase("DESCRIPTION"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "EXPORT_HOSTNAME",
      text: titleCase("EXPORT_HOSTNAME"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "EXPORT_PATHNAME",
      text: titleCase("EXPORT_PATHNAME"),
      sort: true,
      headerStyle: () => {
        return { width: "10%",overflowWrap:'break-word' };
      },
    },
    {
      dataField: "OWNER_EMAIL",
      text: titleCase("OWNER_EMAIL"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "OWNER_EMAIL2",
      text: titleCase("OWNER_EMAIL2"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "START_DATE",
      text: titleCase("START_DATE"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row) => {
        return <>{ToDateText(row.START_DATE)}</>;
      },
    },
    {
      dataField: "END_DATE",
      text: titleCase("END_DATE"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row) => {
        return <>{ToDateText(row.END_DATE)}</>;
      },
    },
    {
      dataField: "SPI_FLAG",
      text: titleCase("SPI_FLAG"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "ACTIVE_FLAG",
      text: titleCase("ACTIVE_FLAG"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
  ];
  return columns;
};

// api
const GetOutboundInventory = async (param) => {
  let url = `${API_URL.Job}/api/Master/GetOutboundInventory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export default withLoadingContext(OutboundInventory);
